import * as React from 'react';
import _ from 'lodash';
import cn from '~modules/cn';
import CheckIcon from '../../../assets/icons/v2design/basics/check.svg';

import './wizard.scss';

type Step = {
    title: string;
    selected: boolean;
    isValid: boolean;
    name: string;
};
type Props = {
    steps: Step[];
    onSelected?: (name: string) => void;
};

export default function WizardSteps({ steps, onSelected }: Props): JSX.Element {
    const selectedIndex = _.findIndex(steps, ({ selected }) => selected);
    const defaultStepNumber = selectedIndex === -1 ? 0 : selectedIndex;
    const [stepNumber, setStepNumber] = React.useState(defaultStepNumber);
    React.useEffect(() => {
        setStepNumber(defaultStepNumber);
    }, [steps, defaultStepNumber]);

    return (
        <div className="wizard-steps">
            {steps.map(({ title, name, isValid }, index) => (
                <div
                    className={cn(
                        'wizard-step',
                        { 'wizard-step--prev': index < stepNumber },
                        { 'wizard-step--invalid': !isValid },
                        { 'wizard-step--current': stepNumber === index }
                    )}
                    key={index}
                    onClick={() => {
                        if (index !== stepNumber) {
                            setStepNumber(index);
                            onSelected?.(name);
                        }
                    }}
                >
                    <span className="step-number">{index <= stepNumber ? <CheckIcon /> : `${index + 1}`}</span>
                    {title && <span className="step-title">{title}</span>}
                </div>
            ))}
        </div>
    );
}
